import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchGeographyData(action) {
  try {
    const { filters } = action.payload;
    
    // Extract the sorting info and other filters
    const { sortDescending, ...otherFilters } = filters;
    
    // Create filtersString for the API call (without sortDescending)
    const filtersString = JSON.stringify(otherFilters);
    
    // Call API with both filtersString and sortDescending
    const response = yield call(API.fetchGeographyAnalytics, { 
      filtersString,
      sortDescending 
    });
    
    const rawData = Array.isArray(response?.data?.data) ? response.data.data : [];
    
    yield put(actions.fetchGeographyDataSuccess({
      data: rawData
    }));
    
  } catch (error) {
    // Check if the task was cancelled
    if (yield cancelled()) {
      return;
    }
    yield put(actions.fetchGeographyDataFailure(error.message || "Failed to load geography data"));
  }
}

export function* geographyAnalyticsSaga() {
  // Use takeLatest to cancel previous requests automatically
  yield takeLatest(actions.fetchGeographyData.type, handleFetchGeographyData);
}